import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

const PricingAppBox = ({app}) => {
  return (
    <div className="application-pricing typography_t4_1">
      {app.isTrial ?
        <span className="free-trial">
          {app.trialDays ?
            <FormattedMessage id="application.price.freeDaysTrial" values={{trialDays: app.trialDays}}/> :
            <FormattedMessage id="application.price.freeTrial" values={{trialDays: app.trialDays}}/>
          }
        </span> :
        <span>
          {!app.premiumOnly ? <span className="free"><FormattedMessage id="application.price.free"/></span> : ''}
          {!app.premiumOnly && (app.hasPremium || app.externalPremium) ? <span className="separator"> / </span> : ''}
          {app.hasPremium || app.premiumOnly || app.externalPremium ? <span className="premium"><FormattedMessage id="application.price.premium"/></span> : ''}
        </span>
      }
    </div>
  );
};

PricingAppBox.propTypes = {
  app: PropTypes.object.isRequired
};

export default PricingAppBox;



// WEBPACK FOOTER //
// ./components/Pricing-app-box.js